import React from "react";
import { Link, NavLink, useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../contexts/I18nContext";
import { LogOut, ArrowLeft } from "lucide-react";

export const DashboardLayout = ({ role, links }) => {
  const { user, logout } = useAuth();
  const { t, lang, toggle } = useI18n();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-neutral-50 font-sans">
      <header className="bg-white border-b border-neutral-200" data-testid="dashboard-header">
        <div className="max-w-[1400px] mx-auto px-6 h-14 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <Link to="/" className="font-serif text-xl tracking-tight flex items-center gap-2" data-testid="dashboard-logo">
              <ArrowLeft size={14} strokeWidth={1.5} /> d-Pod Gallery
            </Link>
            <div className="overline text-neutral-400">
              {role === "admin" ? t.admin.dashboard : t.artist.dashboard}
            </div>
          </div>
          <div className="flex items-center gap-6">
            <button onClick={toggle} className="overline text-neutral-600 hover:text-black" data-testid="dashboard-lang">
              {lang === "es" ? "EN" : "ES"}
            </button>
            <span className="overline text-neutral-500 hidden sm:inline">{user?.name}</span>
            <button onClick={() => { logout(); navigate("/"); }} className="overline text-neutral-700 hover:text-black flex items-center gap-1.5" data-testid="dashboard-logout">
              <LogOut size={14} strokeWidth={1.5} /> {t.nav.logout}
            </button>
          </div>
        </div>
      </header>
      <div className="max-w-[1400px] mx-auto px-6 py-8 grid grid-cols-12 gap-8">
        <aside className="col-span-12 md:col-span-3 lg:col-span-2">
          <nav className="flex md:flex-col gap-1" data-testid="dashboard-nav">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                className={({ isActive }) =>
                  `px-3 py-2 overline border-l-2 transition-colors ${
                    isActive ? "border-black text-black bg-white" : "border-transparent text-neutral-500 hover:text-black"
                  }`
                }
                data-testid={`nav-${l.key}`}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <main className="col-span-12 md:col-span-9 lg:col-span-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
